<template>
    <div class="sub-visual-container">
        <!-- 비주얼: 파트너스 -->
        <div v-if="visual == 'partners'" class="sub-visual sub-visual--partners">
            <div class="sub-visual-inner">
                <h1 class="title">
                    <small>모든 견적 100% 투명 공개!</small>
                    새집처럼 파트너스
                </h1>
                <p class="pr">마음껏 비교하고 선택하세요!</p>
            </div>
        </div>
        <!-- 비주얼: 커뮤니티 -->
        <div v-if="visual == 'community'" class="sub-visual sub-visual--community">
            <div class="sub-visual-inner">
                <h1 class="title">
                    커뮤니티
                </h1>
            </div>
        </div>
        <!-- 비주얼: 견적문의 -->
        <div v-if="visual == 'estimate'" class="sub-visual sub-visual--estimate">
            <div class="sub-visual-inner">
                <h1 class="title">
                    견적문의
                </h1>
            </div>
        </div>
	</div>
</template>

<script>

export default{
    props : {
        visual : {type :String, default : ""}
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>
